import styled, { css, CSSObject } from 'styled-components';
import {
    colorBlack,
    colorGray,
    colorTeal,
    colorWhite,
    mediaMd,
    mediaTablet,
    mediaXs,
} from 'theme/theme-helper-selectors';
import { Icon } from 'kl-b2c-ui-kit';

export const Container = styled.div`
    perspective: 1000px;
    cursor: pointer;
    width: 100%;
    height: 286px;
    flex-grow: 1;
    position: relative;

    @media (${mediaXs}) {
        height: 261px;
        min-height: auto;
        flex-shrink: 0;
        flex-grow: 0;
        flex-basis: auto;
    }

    @media (${mediaXs}) {
        height: 214px;
    }
`;

export const CardHoverBg = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    left: 0;
    top: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
`;

export const CardInner = styled.div<{ $isFlipped: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transform-style: preserve-3d;

    ${({ $isFlipped }) =>
        $isFlipped &&
        css`
            transform: rotateY(180deg);
        `}
`;

const CardFace = styled.div<{ styles?: CSSObject }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    border-radius: 16px;
    padding: 30px;
    display: flex;
    flex-direction: column;

    @media (${mediaXs}) {
        padding: 24px;
    }

    ${({ styles }) => ({ ...styles })};
`;

export const Title = styled.h4<{ front?: boolean }>`
    font-size: 21px;
    line-height: 27px;
    font-weight: 400;
    color: ${({ front }) => (front ? colorBlack : colorWhite)};
`;

export const CardBack = styled(CardFace)<{ gradient: string }>`
    transform: rotateY(180deg);
    overflow-y: auto;
    background: #131313;
    position: relative;
    z-index: 50;
    border: 3px solid transparent;
    background: ${({
        gradient,
    }) => `linear-gradient(#131313, #131313) padding-box,
    ${gradient} border-box`};

    ${Title} {
        font-size: 24px;

        @media (${mediaXs}) {
            font-size: 21px;
        }
    }

    ::-webkit-scrollbar {
        width: 9px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${colorGray};
        height: 30px;
        border-radius: 5px;
    }
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    svg {
        > &:first-child {
            width: 60px;
        }
    }

    @media (${mediaXs}) {
        margin: 0 0 20px 0;
    }
`;

export const RotateIcon = styled(Icon)`
    margin-top: -5px;
    opacity: 0.4;

    @media (${mediaTablet}) {
        display: none;
    }

    @media (${mediaXs}) {
        width: 32px;
    }
`;

export const CardFront = styled(CardFace)`
    ${Title} {
        font-size: 32px;
        line-height: 36px;
        margin-top: 60px;

        @media (${mediaXs}) {
            font-size: 24px;
            line-height: 27px;
        }
    }

    &:hover {
        ${CardHoverBg} {
            opacity: 1;
        }
    }
`;

export const Subtitle = styled.p`
    font-size: 21px;
    line-height: 24px;
    color: ${colorWhite};
    font-weight: 300;
    margin: 12px 0 0 0;
    opacity: 0.6;

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 18px;
    }
`;

export const List = styled.ul`
    margin: 16px 0 0 0;
    padding-left: 20px;
    color: ${colorWhite};
    padding-left: 0;
`;

export const ListItem = styled.li`
    font-size: 20px;
    line-height: 24px;
    list-style: none;
    padding-left: 24px;
    margin: 0 0 8px 0;
    font-weight: 300;
    position: relative;

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 18px;
    }

    span {
        color: ${colorWhite};
        opacity: 0.6;
    }

    a {
        color: ${colorWhite};
        opacity: 0.6;

        &:hover {
            color: ${colorTeal};
        }
    }

    &:before {
        content: '';
        display: block;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background: linear-gradient(
            133.81deg,
            rgba(62, 220, 204, 1),
            rgba(69, 237, 169, 1)
        );
        position: absolute;
        top: 5px;
        left: 0;
    }
`;

export const Disclaimer = styled.div`
    font-size: 14px;
    line-height: 16px;
    color: ${colorWhite};
    margin-top: 5px;
    opacity: 0.6;

    @media (${mediaMd}) {
        font-size: 14px;
        line-height: 15px;
    }

    @media (${mediaXs}) {
        font-size: 12px;
        line-height: 15px;
    }
`;
